module.exports = __webpack_public_path__ + "static/media/head-walls.5005af9f.png";